import { useState } from 'react';
import { Lock, Check, AlertCircle, Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function SetPassword({ token, onComplete }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 6) {
      setError('La password deve avere almeno 6 caratteri');
      return;
    }
    if (password !== confirm) {
      setError('Le password non corrispondono');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/set-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Errore');
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Errore nella configurazione della password');
    }
    setLoading(false);
  };

  if (success) {
    return (
      <div className="min-h-screen bg-[#0a0e14] flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-white/5 border border-white/10 rounded-2xl p-8 text-center">
          <div className="w-16 h-16 bg-emerald-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <Check className="w-8 h-8 text-emerald-400" />
          </div>
          <h2 className="text-white text-xl font-bold mb-2">Password impostata!</h2>
          <p className="text-slate-400 text-sm mb-6">La tua password è stata configurata con successo. Ora puoi accedere alla tua area personale.</p>
          <button
            onClick={() => onComplete && onComplete()}
            className="w-full bg-gradient-to-r from-teal-600 to-teal-500 text-white font-semibold py-3 rounded-xl hover:from-teal-500 hover:to-teal-400 transition-all"
            data-testid="go-to-login"
          >
            Vai al Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0a0e14] flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white/5 border border-white/10 rounded-2xl p-8" data-testid="set-password-page">
        <div className="text-center mb-6">
          <div className="w-14 h-14 bg-teal-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <Lock className="w-7 h-7 text-teal-400" />
          </div>
          <h2 className="text-white text-xl font-bold mb-1">Imposta la tua Password</h2>
          <p className="text-slate-400 text-sm">Configura la password per accedere alla tua area personale eSIM4You.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-slate-400 text-xs uppercase mb-1 block">Nuova Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Minimo 6 caratteri"
              className="w-full bg-black/30 border border-white/10 rounded-xl px-4 py-3 text-white focus:border-teal-500/50 focus:outline-none placeholder-slate-600"
              data-testid="new-password"
              required
            />
          </div>
          <div>
            <label className="text-slate-400 text-xs uppercase mb-1 block">Conferma Password</label>
            <input
              type="password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              placeholder="Ripeti la password"
              className="w-full bg-black/30 border border-white/10 rounded-xl px-4 py-3 text-white focus:border-teal-500/50 focus:outline-none placeholder-slate-600"
              data-testid="confirm-password"
              required
            />
          </div>

          {error && (
            <div className="flex items-center gap-2 bg-rose-500/10 border border-rose-500/30 rounded-lg px-3 py-2">
              <AlertCircle className="w-4 h-4 text-rose-400 flex-shrink-0" />
              <span className="text-rose-300 text-sm">{error}</span>
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-teal-600 to-teal-500 text-white font-semibold py-3 rounded-xl hover:from-teal-500 hover:to-teal-400 transition-all disabled:opacity-50 flex items-center justify-center gap-2"
            data-testid="submit-password"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Imposta Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
